import React from 'react'
import './partenaire.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const partner = [
    {
        id: 1,
        img: './LOGO_CLIENT/Logo_Afriland.png'
    },
    {
        id: 2,
        img: './LOGO_CLIENT/logo_tiof-.png'
    },
    {
        id: 3,
        img: './LOGO_CLIENT/Logo-DAK.jpg'
    },
    {
        id: 4,
        img: './LOGO_CLIENT/ok_foods.jpg'
    },
    {
        id: 5,
        img: './LOGO_CLIENT/ozil-logo.png'
    },
    {
        id: 6,
        img: './LOGO_CLIENT/polypharma.png'
    },
    {
        id: 7,
        img: './LOGO_CLIENT/soticam.png'
    }
];
export const  Partenaires = () => {

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1, 
            }
        }]
        /*appendDots: (dots) => {
          return <ul style={{margin: "0px"}}>{dots}</ul>
        }*/
      }
   
    return (
        <>
           <div className='slide'>
           <div className="heading"><h6>Ils nous font confiance</h6></div>
           <div className='car'>
           <Slider {...settings}>
            { partner.map((val, index) => {
                return (<div className='items' key={index}>
                   <div className='box shadow'>
                     <div className='images row'>
                        <div className='img'>
                           <img src={val.img} alt=""/>
                        </div>
                     </div>
                   </div>
                </div>
              )
            })}
            </Slider>
            </div>
          </div>
        </>
    )
  }